// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Zoom: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21">
            <path
                fill="currentColor"
                d="M8.125 2.375a6.25 6.25 0 1 1 0 12.5 6.25 6.25 0 0 1 0-12.5Zm0 14.375c1.906 0 3.66-.656 5.043-1.754l4.844 4.844.664.664L20 19.176l-.664-.664-4.844-4.844a8.066 8.066 0 0 0 1.758-5.043A8.124 8.124 0 0 0 8.125.5 8.124 8.124 0 0 0 0 8.625a8.124 8.124 0 0 0 8.125 8.125ZM7.188 13h1.875V9.562H12.5V7.688H9.063V4.25H7.188V7.688H3.75v1.875H7.188V13Z"
            />
        </svg>
    );
};

export default React.memo(Zoom);
